<template>
  <budgets-list
    :budgets="budgets"
    :mentor="true"
    :showOverlay="showOverlay"
  ></budgets-list>
</template>

<script>
import BudgetsList from "@/components/tools/budgets/BudgetsList"
import User from "@/lib/user"

export default {
  components: {
    BudgetsList
  },
  computed: {
    userId() {
      return this.$route.params.id
    },
    budgets() {
      let budgets = this.$store.getters["budgets/getBudgetsByUser"](this.userId)
      return budgets ? budgets : []
    }
  },
  data() {
    return {
      showOverlay: false
    }
  },
  created() {
    this.$store.dispatch("budgets/loadBudgets", this.userId)
  },

  beforeRouteUpdate(to, from, next) {
    if (to.params.id) {
      this.$store.dispatch("budgets/loadBudgets", to.params.id)
    }
    next()
  }
}
</script>
